// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2mS5B","search":"Settings_search__KrHrt","filter":"Settings_filter__kB3d2"};